import * as colors from './colors';
import * as msg from './messages';
import * as con from './const';
import * as sizes from './sizes';

export const AppColors = colors;
export const AppMessages = msg;
export const AppConst = con;
export const AppSizes = sizes;
